'use client';

import type { BaseComponentProps } from '../base-component.types';
import { Skeleton } from '../skeleton';
import { Table } from './Table';

export type TableSkeletonProps = BaseComponentProps & {
  columns: number;
  items: number;
};

function TableSkeleton({
  style,
  className,
  columns,
  items,
}: TableSkeletonProps) {
  const tableItems = Array.from(Array(items)).map((_, index) => ({
    index: `index-${index}`,
  }));

  return (
    <Table.Body items={tableItems} style={style} className={className}>
      {(item) => (
        <Table.Row id={item.index} isSelectable={false}>
          {Array.from(Array(columns)).map((_, index) => (
            <Table.Cell key={index}>
              <Skeleton />
            </Table.Cell>
          ))}
        </Table.Row>
      )}
    </Table.Body>
  );
}

export { TableSkeleton };
